import React, { useEffect, useState } from "react";
import { api, formatPrice } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { Plus, Trash2, Ban, ShieldCheck, X } from "lucide-react";

// ===== ORDERS =====
export function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const load = async () => {
    try {
      const r = await api.get("/admin/orders");
      setOrders(r.data);
    } catch (e) { console.error(e); }
  };
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await api.get("/admin/orders");
        if (mounted) setOrders(r.data);
      } catch (e) { console.error(e); }
    })();
    return () => { mounted = false; };
  }, []);
  const updateStatus = async (id, status) => {
    await api.post(`/admin/orders/${id}/status`, { status });
    load();
  };
  return (
    <div className="space-y-6" data-testid="admin-orders">
      <h1 className="font-display text-2xl font-bold text-white">Pedidos</h1>
      <div className="rounded-2xl bg-[#171723] border border-white/5 p-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs text-slate-500"><tr>
            <th className="text-left px-2 py-2">ID</th><th className="text-left px-2 py-2">Cliente</th><th className="text-left px-2 py-2">Total</th>
            <th className="text-left px-2 py-2">Pagamento</th><th className="text-left px-2 py-2">Status</th><th className="text-left px-2 py-2">Data</th>
          </tr></thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-t border-white/5">
                <td className="px-2 py-3 text-white font-medium">#{o.id.slice(0,8).toUpperCase()}</td>
                <td className="px-2 py-3 text-slate-300">{o.user_email}</td>
                <td className="px-2 py-3 text-white font-semibold">{formatPrice(o.total)}</td>
                <td className="px-2 py-3 text-slate-300 capitalize">{o.payment_status}</td>
                <td className="px-2 py-3">
                  <select value={o.status} onChange={(e) => updateStatus(o.id, e.target.value)} className="bg-white/5 border border-white/10 rounded px-2 py-1 text-xs text-white" data-testid={`order-status-${o.id}`}>
                    {["pending","completed","cancelled","refunded"].map((s) => <option key={s} value={s} className="bg-[#171723]">{s}</option>)}
                  </select>
                </td>
                <td className="px-2 py-3 text-slate-400 text-xs">{new Date(o.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <div className="text-center py-8 text-slate-500">No orders yet</div>}
      </div>
    </div>
  );
}

// ===== USERS =====
export function AdminUsers() {
  const [users, setUsers] = useState([]);
  const load = async () => {
    try {
      const r = await api.get("/admin/users");
      setUsers(r.data);
    } catch (e) { console.error(e); }
  };
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await api.get("/admin/users");
        if (mounted) setUsers(r.data);
      } catch (e) { console.error(e); }
    })();
    return () => { mounted = false; };
  }, []);
  const ban = async (u) => { await api.post(`/admin/users/${u.id}/ban`, { banned: !u.banned }); load(); };
  return (
    <div className="space-y-6" data-testid="admin-users">
      <h1 className="font-display text-2xl font-bold text-white">Usuários</h1>
      <div className="rounded-2xl bg-[#171723] border border-white/5 p-4 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs text-slate-500"><tr>
            <th className="text-left px-2 py-2">Nome</th><th className="text-left px-2 py-2">Email</th><th className="text-left px-2 py-2">Role</th>
            <th className="text-left px-2 py-2">Status</th><th className="text-left px-2 py-2">Cadastro</th><th className="px-2 py-2"></th>
          </tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-white/5">
                <td className="px-2 py-3 text-white font-medium">{u.name}</td>
                <td className="px-2 py-3 text-slate-300">{u.email}</td>
                <td className="px-2 py-3 text-slate-300 capitalize">{u.role}</td>
                <td className="px-2 py-3">{u.banned ? <span className="px-2 py-0.5 rounded-full text-xs bg-red-500/15 text-red-400">Banned</span> : <span className="px-2 py-0.5 rounded-full text-xs bg-emerald-500/15 text-emerald-400">Active</span>}</td>
                <td className="px-2 py-3 text-slate-400 text-xs">{new Date(u.created_at).toLocaleDateString()}</td>
                <td className="px-2 py-3 text-right"><Button variant="outline" size="sm" onClick={() => ban(u)} className="border-white/10 text-slate-300 hover:bg-white/5" data-testid={`ban-${u.id}`}>{u.banned ? <ShieldCheck className="w-3.5 h-3.5 mr-1" /> : <Ban className="w-3.5 h-3.5 mr-1" />}{u.banned ? "Unban" : "Ban"}</Button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ===== CATEGORIES =====
export function AdminCategories() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", slug: "", icon: "Gamepad2" });
  const load = async () => {
    try {
      const r = await api.get("/categories");
      setItems(r.data);
    } catch (e) { console.error(e); }
  };
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await api.get("/categories");
        if (mounted) setItems(r.data);
      } catch (e) { console.error(e); }
    })();
    return () => { mounted = false; };
  }, []);
  const add = async () => {
    if (!form.name) return;
    const slug = form.slug || form.name.toLowerCase().replace(/\s+/g, "-");
    await api.post("/categories", { ...form, slug });
    setForm({ name: "", slug: "", icon: "Gamepad2" });
    load();
  };
  const del = async (id) => { await api.delete(`/categories/${id}`); load(); };
  return (
    <div className="space-y-6" data-testid="admin-categories">
      <h1 className="font-display text-2xl font-bold text-white">Categorias</h1>
      <div className="rounded-2xl bg-[#171723] border border-white/5 p-5">
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mb-4">
          <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
          <input placeholder="slug (optional)" value={form.slug} onChange={(e) => setForm({ ...form, slug: e.target.value })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
          <input placeholder="Icon (Gamepad2…)" value={form.icon} onChange={(e) => setForm({ ...form, icon: e.target.value })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
          <Button onClick={add} className="bg-[#A855F7] hover:bg-[#9333EA]" data-testid="add-category"><Plus className="w-4 h-4 mr-1.5" /> Add</Button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {items.map((c) => (
            <div key={c.id} className="rounded-xl bg-white/5 p-4 flex items-center justify-between border border-white/5">
              <div><div className="font-semibold text-white">{c.name}</div><div className="text-xs text-slate-500">{c.slug}</div></div>
              <button onClick={() => del(c.id)} className="text-slate-400 hover:text-red-400 p-1.5 rounded hover:bg-red-500/10" data-testid={`cat-del-${c.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ===== COUPONS =====
export function AdminCoupons() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ code: "", discount_percent: 10 });
  const load = async () => {
    try {
      const r = await api.get("/coupons");
      setItems(r.data);
    } catch (e) { console.error(e); }
  };
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await api.get("/coupons");
        if (mounted) setItems(r.data);
      } catch (e) { console.error(e); }
    })();
    return () => { mounted = false; };
  }, []);
  const add = async () => {
    if (!form.code) return;
    await api.post("/coupons", { ...form, discount_percent: parseFloat(form.discount_percent), active: true, max_uses: 0 });
    setForm({ code: "", discount_percent: 10 });
    load();
    toast.success("Coupon created");
  };
  const del = async (id) => { await api.delete(`/coupons/${id}`); load(); };
  return (
    <div className="space-y-6" data-testid="admin-coupons">
      <h1 className="font-display text-2xl font-bold text-white">Cupons</h1>
      <div className="rounded-2xl bg-[#171723] border border-white/5 p-5">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
          <input placeholder="CODE" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
          <input type="number" placeholder="Discount %" value={form.discount_percent} onChange={(e) => setForm({ ...form, discount_percent: e.target.value })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
          <Button onClick={add} className="bg-[#A855F7] hover:bg-[#9333EA]" data-testid="add-coupon"><Plus className="w-4 h-4 mr-1.5" /> Create</Button>
        </div>
        <div className="space-y-2">
          {items.map((c) => (
            <div key={c.id} className="flex items-center justify-between rounded-xl bg-white/5 px-4 py-3 border border-white/5">
              <div><div className="font-mono font-bold text-[#C084FC]">{c.code}</div><div className="text-xs text-slate-500">{c.discount_percent}% off • {c.uses} uses</div></div>
              <button onClick={() => del(c.id)} className="text-slate-400 hover:text-red-400 p-1.5 rounded hover:bg-red-500/10" data-testid={`coupon-del-${c.id}`}><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ===== BANNERS =====
export function AdminBanners() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", subtitle: "", image: "", cta_text: "Shop Now", cta_link: "/catalog", active: true, order: 0 });
  const load = async () => {
    try {
      const r = await api.get("/banners");
      setItems(r.data);
    } catch (e) { console.error(e); }
  };
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const r = await api.get("/banners");
        if (mounted) setItems(r.data);
      } catch (e) { console.error(e); }
    })();
    return () => { mounted = false; };
  }, []);
  const add = async () => {
    if (!form.title || !form.image) return;
    await api.post("/banners", form);
    setForm({ title: "", subtitle: "", image: "", cta_text: "Shop Now", cta_link: "/catalog", active: true, order: 0 });
    load();
  };
  const del = async (id) => { await api.delete(`/banners/${id}`); load(); };
  return (
    <div className="space-y-6" data-testid="admin-banners">
      <h1 className="font-display text-2xl font-bold text-white">Banners</h1>
      <div className="rounded-2xl bg-[#171723] border border-white/5 p-5 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <input placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
        <input placeholder="Image URL" value={form.image} onChange={(e) => setForm({ ...form, image: e.target.value })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
        <input placeholder="Subtitle" value={form.subtitle} onChange={(e) => setForm({ ...form, subtitle: e.target.value })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
        <input placeholder="CTA Link" value={form.cta_link} onChange={(e) => setForm({ ...form, cta_link: e.target.value })} className="h-10 px-3 rounded-lg bg-white/5 border border-white/10 text-sm text-white" />
        <Button onClick={add} className="bg-[#A855F7] hover:bg-[#9333EA] lg:col-span-2"><Plus className="w-4 h-4 mr-1.5" /> Add Banner</Button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((b) => (
          <div key={b.id} className="rounded-2xl bg-[#171723] border border-white/5 overflow-hidden">
            <img src={b.image} alt={b.title} className="aspect-video w-full object-cover" />
            <div className="p-4">
              <div className="font-semibold text-white">{b.title}</div>
              <div className="text-xs text-slate-500 mb-3">{b.subtitle}</div>
              <Button variant="outline" size="sm" onClick={() => del(b.id)} className="border-white/10 text-slate-300 w-full"><Trash2 className="w-3.5 h-3.5 mr-1.5" /> Remove</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ===== Generic STUB =====
export function AdminStub({ title, description }) {
  return (
    <div className="space-y-6">
      <h1 className="font-display text-2xl font-bold text-white">{title}</h1>
      <div className="rounded-2xl bg-[#171723] border border-white/5 p-10 text-center">
        <div className="w-12 h-12 rounded-full bg-[#A855F7]/15 grid place-items-center mx-auto mb-3 text-[#A855F7]">
          <ShieldCheck className="w-5 h-5" />
        </div>
        <h3 className="font-display text-lg font-bold text-white">{title}</h3>
        <p className="text-slate-400 text-sm mt-2 max-w-md mx-auto">{description}</p>
      </div>
    </div>
  );
}
